import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import styles from './ConversionFormInfo.css';
import Price from '../common/Price';
import { SUBSCRIPTION_PLANS, PLAN_ID_PP_1M } from '../../constants';
import TrialDurationString from '../common/TrialDurationString';

const ConversionFormInfo = ({ trialDurationDays }) => {
  return (
    <section className={styles.section}>
      <div className={styles.image} />
      <div className={styles.content}>
        <div className={styles.logo} />
        <h1 className={styles.headline}>
          {trialDurationDays > 0 ? (
            <FormattedMessage
              id="conversion-form.info.headline"
              defaultMessage="{duration} of Premium on us. Why wait?"
              values={{ duration: <TrialDurationString duration={trialDurationDays} /> }}
            />
          ) : (
            <FormattedMessage
              id="conversion-form.info.headline.no-trial"
              defaultMessage="Step up to your Premium benefits"
            />
          )}
        </h1>
        <p className={styles.description}>
          <FormattedMessage
            id="conversion-form.info.description"
            defaultMessage="Stream high-quality audio and support artists with every play."
          />
        </p>
        <h2 className={styles.cta}>
          {trialDurationDays > 0 ? (
            <FormattedMessage
              id="conversion-form.info.enjoy-free-trial"
              defaultMessage="Enjoy {duration} days free"
              values={{ duration: trialDurationDays }}
            />
          ) : (
            <FormattedMessage
              id="conversion-form.info.unlock-premium"
              defaultMessage="Unlock IDAGIO Premium"
            />
          )}
        </h2>
        {trialDurationDays > 0 && (
          <React.Fragment>
            <p className={styles.priceLine}>
              <span className={styles.priceLineHighlight}>
                <FormattedMessage
                  id="conversion-form.info.free-trial.duration"
                  defaultMessage="{duration} days free trial,"
                  values={{ duration: trialDurationDays }}
                />
              </span>{' '}
              <span className={styles.priceLineMuted}>
                <FormattedMessage
                  id="conversion-form.info.free-trial.price"
                  defaultMessage="then only {price}/month."
                  values={{
                    price: <Price price={SUBSCRIPTION_PLANS[PLAN_ID_PP_1M].monthlyPrice} />,
                  }}
                />
              </span>
            </p>
            <p className={styles.disclaimer}>
              <FormattedMessage
                id="conversion-form.info.no-commitment"
                defaultMessage="No payment now, cancel anytime."
              />
            </p>
          </React.Fragment>
        )}
        <div className={styles.arrowAnim}>
          <div className={styles.arrow} />
        </div>
      </div>
    </section>
  );
};

ConversionFormInfo.propTypes = {
  trialDurationDays: PropTypes.number.isRequired,
};

export default ConversionFormInfo;
